import UsersResult from './ResultPage';

export default UsersResult;
